import axiosInstance from "../server/axios";
import { toast } from 'react-toastify';

const getMachineIP = async () => {
    try {
      // Try multiple services for reliability
      const services = [
        'https://api.ipify.org?format=json',
        'https://api64.ipify.org?format=json',
        'https://ip.seeip.org/json'
      ];
      
      for (const service of services) {
        try {
          const response = await fetch(service, { 
            timeout: 5000 
          });
          const data = await response.json();
          return data.ip;
        } catch (error) {
          console.warn(`IP service ${service} failed:`, error);
          continue;
        }
      }
      return null;
    } catch (error) {
      console.error('All IP services failed:', error);
      return null;
    }
  };
  
  export const loginApi = async (login, password) => {
    try {
      const machineIP = await getMachineIP();
      
      const requestData = {
        login,
        password,
        ipAdress: machineIP,
        timestamp: new Date().toISOString(),
        user_agent: navigator.userAgent
      };
  
      const response = await axiosInstance.post('/login', requestData);
      
      if (response.data.requires_otp) {
        return {
          requiresTwoFactor: true,
          email: response.data.email,
          message: response.data.message
        };
      }
      
      const { token, user } = response.data;
      localStorage.setItem('authToken', token);
      localStorage.setItem('user', JSON.stringify(user));
      localStorage.setItem('role', user.roles?.[0]?.name || 'client');
      
      return user;
    } catch (error) {
      throw error;
    }
  };

export const verifyTwoFactorApi = async (email, code, type = 'login') => {
  try {
    const endpoint = type === 'register' ? '/verify-register' : '/verify-login-otp';
    const response = await axiosInstance.post(endpoint, {
      email: email,
      code: code
    });
    
    const { token, user } = response.data;
    localStorage.setItem('authToken', token);
    localStorage.setItem('user', JSON.stringify(user));
    localStorage.setItem('role', user.roles?.[0]?.name || 'client');
    
    return user;
  } catch (error) {
    throw error;
  }
};

export const resendVerificationCodeApi = async (email, type = 'login') => {
  try {
    const endpoint = type === 'register' ? '/resend-register-code' : '/resend-login-otp';
    const response = await axiosInstance.post(endpoint, {
      email: email
    });
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const googleLoginRequest = async (response) => {
  try {
      const { credential } = response; // Get the Google token
      const machineIP = await getMachineIP();
      const res = await axiosInstance.post('/auth/google', {
          token: credential,
          ipAdress: machineIP,
      });

      if (res.data.success) {
          // Store token or handle login state
          localStorage.setItem("authToken", res.data.token);
          localStorage.setItem('user', JSON.stringify(res.data.user));
          localStorage.setItem('role', 'client');

          return res.data.user;
      } else {
          toast.error("Google login failed!");
      }
  } catch (error) {
      console.error("Google login error:", error);
      toast.error("Google login error");
  }
};